/**
 * Build analytics POST body for cookie-banner consent events.
 * @param {string} event
 * @param {object|null} consentDetail - storeConsent return value or event.detail
 * @param {{ country?: string, device?: string, instanceId?: string|null }} [meta]
 */
export function buildAnalyticsPayload(event, consentDetail = null, meta = {}) {
  const payload = { event };

  if (meta.country) payload.country = meta.country;
  if (meta.device) payload.device = meta.device;
  if (meta.instanceId) payload.instance_id = meta.instanceId;

  if (!consentDetail || typeof consentDetail !== 'object') {
    try {
      payload.page_url = window.location.href;
    } catch (_) {}
    return payload;
  }

  if (consentDetail.consent_id) payload.consent_id = consentDetail.consent_id;
  if (consentDetail.categories && typeof consentDetail.categories === 'object') {
    payload.categories = {
      statistics: !!consentDetail.categories.statistics,
      marketing: !!consentDetail.categories.marketing,
      preferences: !!consentDetail.categories.preferences,
    };
  }
  if (consentDetail.action) payload.action = consentDetail.action;

  try {
    payload.page_url = window.location.href;
  } catch (_) {}

  return payload;
}
